import * as React from "react"
import { cn } from "@/lib/utils"

interface AppleButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "danger" | "tertiary" | "heartbeat"
  size?: "sm" | "md" | "lg"
}

export const AppleButton = React.forwardRef<HTMLButtonElement, AppleButtonProps>(
  ({ className, variant = "primary", size = "md", ...props }, ref) => {
    return (
      <button
        className={cn(
          // Base styles
          "inline-flex items-center justify-center rounded-apple font-medium transition-colors",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-apple-blue",
          // Size variants
          {
            "h-9 px-4 text-sm": size === "sm",
            "h-11 px-6 text-base": size === "md",
            "h-12 px-8 text-lg": size === "lg",
          },
          // Color variants
          {
            "bg-apple-blue text-white hover:bg-apple-blue/90": variant === "primary",
            "bg-apple-light-gray text-black hover:bg-apple-gray/20": variant === "secondary",
            "bg-apple-red text-white hover:bg-apple-red/90": variant === "danger",
            "bg-[#1d1d1f] text-white hover:bg-[#1d1d1f]/90": variant === "tertiary",
            "bg-apple-blue text-white hover:bg-apple-blue/90 animate-glow shadow-lg shadow-apple-blue/100": variant === "heartbeat",
          },
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

// Add keyframes for glow animation
const style = document.createElement('style');
style.textContent = `
  @keyframes glow {
    0% { 
      box-shadow: 0 0 15px rgba(0, 122, 255, 0.4),
                 0 0 30px rgba(0, 122, 255, 0.3);
    }
    50% { 
      box-shadow: 0 0 30px rgba(0, 122, 255, 0.6),
                 0 0 30px rgba(0, 122, 255, 0.4);
    }
    100% { 
      box-shadow: 0 0 15px rgba(0, 122, 255, 0.4),
                 0 0 30px rgba(0, 122, 255, 0.3);
    }
  }

  .animate-glow {
    animation: glow 1s ease-in-out infinite;
  }
`;
document.head.appendChild(style); 